import React, { useState } from 'react';
import { bool, string, shape, number } from 'prop-types';
import Popover from 'ps-components/Popover/Popover';
import cn from 'classnames';
import './SlotteeInfo.scss';

SlotteeInfo.propTypes = {
  hide: bool,
  usedJobs: shape({
    org_job_code: string,
    org_job_code_key: string,
    org_job_id: number,
    org_job_title: string
  })
};

export default function SlotteeInfo(props) {
  const { hide, usedJobs } = props;
  const [showPopover, setShowPopover] = useState(false);

  function togglePopover(event) {
    event?.stopPropagation();
    setShowPopover(!showPopover);
  }

  if (hide) {
    return null;
  }

  function getUsedModalJobs() {
    return (
      usedJobs?.map(job => {
        return (
          <div className="used-jobs__list-item">
            <a className="used-jobs__link" href={`../../jobs/${job.org_job_id}/slotted`} target="_blank">
              {job.org_job_title}
              {job.org_job_code && ` - ${job.org_job_code}`}
              {job.org_job_code_key && job.org_job_code_key !== ' ' && `, ${job.org_job_code_key}`}
            </a>
          </div>
        );
      }) || []
    );
  }

  return (
    <div className="market-pricing__slottee-info">
      <div className="market-pricing__slottee-title">Slottee Job</div>

      <div className="icon-reverse icon-circle">
        <i
          onClick={togglePopover}
          title="This is a slottee job"
          className="icon-info market-pricing__slottee-info-icon-info"
        />

        <div className="market-pricing__slottee-info-popover">
          {showPopover && (
            <Popover
              popoverClassnames={cn('market-pricing__slottee-info-popover-inner', { scroll: usedJobs?.length > 3 })}
              relativeElement={document.querySelector('div#market-pricing__slottee-info-popover')}
              display={true}
              arrowAlign="left"
              togglePopover={togglePopover}
            >
              <div className="slottee-text">
                This is a slottee job. Changes made to its pricing will affect the following slotted jobs:
                <div className="used-list">{getUsedModalJobs()}</div>
              </div>
            </Popover>
          )}
        </div>
      </div>
    </div>
  );
}
